import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { PromotionsService } from '../../promotions.service';
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { formatDate } from '@angular/common';
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import * as moment from 'moment';
import { JwtHelperService } from "@auth0/angular-jwt";
const helper = new JwtHelperService();
@Component({
  selector: 'app-assign-promotions',
  templateUrl: './assign-promotions.component.html',
  styleUrls: ['./assign-promotions.component.scss']
})
export class AssignPromotionsComponent extends FeaturesBaseComponent implements OnInit {
  @Input() codeGroups;
  @Input() carrierDetails;
  @Input() serviceCountries;
  numberMask = createNumberMask({
    prefix: '$ ',
    suffix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol :',',
    allowDecimal :true,
  })
  carrierPromoForm: FormGroup;
  carrierPromoId: any;
  carrierpromoDetails: any;
  promotionsCarriers:any= [];
  skulist:any= [];
  productdetails: any;
  productName: string;
  userRole: string = "";
  readonly:boolean = false;
  //codeGroups:any= [];
  //serviceCountries:any= [];

  constructor(private activeRoute: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    private promotionService: PromotionsService) {
    super();
    const token: string = localStorage.getItem("accessToken");
    let decoded_token: any = helper.decodeToken(token);
    this.userRole = decoded_token.role;

    //this.codeGroups = this.promotionService.getcodeGroups();
    //this.serviceCountries = this.promotionService.getCarrierCountries();
    this.carrierPromoId = this.activeRoute.snapshot.params.id;
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.initcarrierPromoForm();
  }
  initcarrierPromoForm(){
    this.carrierPromoForm = new FormGroup({
      editedPromotionName: new FormControl('', [Validators.required]),
      promotionHeaderEnglish: new FormControl('', [Validators.required]),
      promotionHeaderSpanish: new FormControl(''),
      additionalInfo: new FormControl('', [Validators.required]),
      minTopUpAmount: new FormControl(''),
      vendorName: new FormControl(''),
      editedPromotionDescription: new FormControl('', [Validators.required]),
      spanishDescription: new FormControl(''),
      promotionStartdttm: new FormControl(''),
      promotionEnddttm: new FormControl(''),
      applicableMinAmount: new FormControl(''),
      applicableMaxAmount: new FormControl(''),
      tilaCodeGroup: new FormControl('', [Validators.required]),
      tilaCountry: new FormControl('', [Validators.required]),
      tilaCarrier: new FormControl('', [Validators.required]),
      tilaProductId: new FormControl('', [Validators.required]),
      editedPromotionNameApp: new FormControl('', [Validators.required]),
      editedPromotionNameTxtMsg: new FormControl('', [Validators.required]),
      editedPromotionDescApp: new FormControl('', [Validators.required]),
      editedPromotionDescTxtMsg: new FormControl('', [Validators.required]),
      isCertified: new FormControl('')
    })
  }
  get f(){
    return this.carrierPromoForm.controls;
  }

  ngOnDestroy():void{
    super.ngOnDestroy()
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['codeGroups']) {
      this.codeGroups = changes['codeGroups'].currentValue;
    }

    if (changes['serviceCountries']) {
      this.serviceCountries = [];//changes['serviceCountries'].currentValue;
    }
    if (changes['carrierDetails']) {
      this.carrierDetails = changes['carrierDetails'].currentValue;

      //this.carrierPromoId = this.activeRoute.snapshot.params.id;
      //getProductDetails


      if (this.carrierDetails && this.carrierDetails) {


            this.carrierpromoDetails = this.carrierDetails;

            this.ongetCountries();
            this.ongetCarriersList();
            this.ongetsku();
            //this.promotionsCarriers.push(this.carrierpromoDetails.tilaCarrier);
            // this.skulist['sku'] = this.carrierpromoDetails.tilaSku;
            //this.skulist.push({"productId":this.carrierpromoDetails.tilaProductId,"productName":this.carrierpromoDetails.productName});
            //this.serviceCountries.push(this.carrierpromoDetails.tilaCountry);
            //this.skulist.push(this.productdetails.tilaCountry);

            this.carrierPromoForm.get('additionalInfo').setValue(this.carrierpromoDetails.additionalInfo),
            this.carrierPromoForm.get('vendorName').setValue(this.carrierpromoDetails.vendorName),
            this.carrierPromoForm.get('minTopUpAmount').setValue(this.carrierpromoDetails.minTopUpAmount),
            this.carrierPromoForm.get('editedPromotionName').setValue(this.carrierpromoDetails.editedPromotionName),
            this.carrierPromoForm.get('promotionHeaderEnglish').setValue(this.carrierpromoDetails.promotionHeaderEnglish),
            this.carrierPromoForm.get('promotionHeaderSpanish').setValue(this.carrierpromoDetails.promotionHeaderSpanish),
            this.carrierPromoForm.get('editedPromotionDescription').setValue(this.carrierpromoDetails.editedPromotionDescription),
            this.carrierPromoForm.get('spanishDescription').setValue(this.carrierpromoDetails.spanishDescription),
            this.carrierPromoForm.get('promotionStartdttm').setValue(moment(this.carrierpromoDetails.promotionStartdttm).format()),
            this.carrierPromoForm.get('promotionEnddttm').setValue(moment(this.carrierpromoDetails.promotionEnddttm).format()),
            this.carrierPromoForm.get('applicableMinAmount').setValue(this.carrierpromoDetails.applicableMinAmount),
            this.carrierPromoForm.get('applicableMaxAmount').setValue(this.carrierpromoDetails.applicableMaxAmount),
            this.carrierPromoForm.get('tilaCodeGroup').setValue(this.carrierpromoDetails.tilaCodeGroup),
            this.carrierPromoForm.get('tilaCountry').setValue(this.carrierpromoDetails.tilaCountry),
            this.carrierPromoForm.get('tilaCarrier').setValue(this.carrierpromoDetails.tilaCarrier),
            this.carrierPromoForm.get('tilaProductId').setValue(this.carrierpromoDetails.tilaProductId),
            this.carrierPromoForm.get('editedPromotionNameApp').setValue(this.carrierpromoDetails.editedPromotionNameApp),
            this.carrierPromoForm.get('editedPromotionNameTxtMsg').setValue(this.carrierpromoDetails.editedPromotionNameTxtMsg),
            this.carrierPromoForm.get('editedPromotionDescApp').setValue(this.carrierpromoDetails.editedPromotionDescApp),
            this.carrierPromoForm.get('editedPromotionDescTxtMsg').setValue(this.carrierpromoDetails.editedPromotionDescTxtMsg),
            this.carrierPromoForm.get('isCertified').setValue(this.carrierpromoDetails.isCertified)

      }

    }
  }

  onCarrierFormSubmit(e){
    if (this.carrierPromoForm.valid) {
      const dialogRef = this.dialog.open(DialogComponent, {
        data: {
          message: 'pages.placeholders.Areyousureyouwanttosavethechanges',
          buttonText: {
            ok: 'pages.placeholders.Save',
            cancel: 'pages.placeholders.cancel'
          }
        }
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.setSubmitParameters()
        }else{
          this.router.navigate(['features/promotions/carrier-promotions'])
        }
      });

    }
  }
  setSubmitParameters(){


    let formData: Params = {
      carrierPromotionId: this.carrierPromoId,
      additionalInfo: this.carrierPromoForm.get('additionalInfo').value,
      vendorName: this.carrierPromoForm.get('vendorName').value,
      minTopUpAmount: this.carrierPromoForm.get('minTopUpAmount').value.replace('$','').replace(',','').replace(' ',''),
      editedPromotionName: this.carrierPromoForm.get('editedPromotionName').value,
      promotionHeaderEnglish: this.carrierPromoForm.get('promotionHeaderEnglish').value,
      promotionHeaderSpanish: this.carrierPromoForm.get('promotionHeaderSpanish').value,
      editedPromotionDescription: this.carrierPromoForm.get('editedPromotionDescription').value,
      spanishDescription: this.carrierPromoForm.get('spanishDescription').value,
      promotionStartdttm: moment(this.carrierPromoForm.get('promotionStartdttm').value).format('MM-DD-YYYY'),
      promotionEnddttm: moment(this.carrierPromoForm.get('promotionEnddttm').value).format('MM-DD-YYYY'),
      //promotionStartdttm: formatDate(this.carrierPromoForm.get('promotionStartdttm').value, 'yyyy-MM-dd', 'en'),
      //promotionEnddttm: formatDate(this.carrierPromoForm.get('promotionEnddttm').value, 'yyyy-MM-dd', 'en'),
      applicableMinAmount: this.carrierPromoForm.get('applicableMinAmount').value.replace('$','').replace(',','').replace(' ',''),
      applicableMaxAmount: this.carrierPromoForm.get('applicableMaxAmount').value.replace('$','').replace(',','').replace(' ',''),
      tilaCodeGroup: this.carrierPromoForm.get('tilaCodeGroup').value,
      tilaCountry: this.carrierPromoForm.get('tilaCountry').value,
      tilaCarrier: this.carrierPromoForm.get('tilaCarrier').value,
      tilaProductId: this.carrierPromoForm.get('tilaProductId').value,
      editedPromotionNameApp: this.carrierPromoForm.get('editedPromotionNameApp').value,
      editedPromotionNameTxtMsg: this.carrierPromoForm.get('editedPromotionNameTxtMsg').value,
      editedPromotionDescApp: this.carrierPromoForm.get('editedPromotionDescApp').value,
      editedPromotionDescTxtMsg: this.carrierPromoForm.get('editedPromotionDescTxtMsg').value,
      isCertified: this.carrierPromoForm.get('isCertified').value ? 'Yes' : 'No'
};

    this.promotionService.updatecarrierPromotions(formData).subscribe(
      res => {
        if (res && res) {
          if(res.httpcode == 200 && res.responseCodes.find(x => x == "TILA_101") || res.responseStatus == 'Success'){
            this.router.navigate(['features/promotions/carrier-promotions'])
            this.toastrService.success('Carrier Promotion updated successfully', 'Success', {
              timeOut: 3000,
            });
        }
        }

      }
    );
  }
  onCancel() {
    const dialogRefCancel = this.dialog.open(DialogComponent, {

      data: {
        message: 'pages.placeholders.Areyousureyouwanttocancelthechanges',
        buttonText: {
          ok: 'pages.newRetailer.yes',
          cancel: 'pages.newRetailer.cancel'
        }
      }
    });

    dialogRefCancel.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.router.navigateByUrl('features/promotions/carrier-promotions')
      }
    });
  }
  onCheckCertify(e){

    //alert(e.value)
  }

  getCountries(e){
    let CodeGroup =this.carrierPromoForm.get('tilaCodeGroup').value;
    this.serviceCountries = [];
    this.promotionService.getCountries(CodeGroup).subscribe(
      res => {
        let _carriers: any = res;
        if (_carriers.httpcode == 200) {
          this.serviceCountries = _carriers.data;
          this.promotionsCarriers=[];
          this.skulist=[];
        }
      });
    }
    getCarriersList(e){
      let CodeGroup =this.carrierPromoForm.get('tilaCodeGroup').value;
      let country =this.carrierPromoForm.get('tilaCountry').value;
      this.promotionsCarriers = []
      this.promotionService.getCarriersList(CodeGroup,country).subscribe(
        res => {
          let _carriers: any = res;
          if (_carriers.httpcode == 200) {
            this.promotionsCarriers = _carriers.data;
            this.skulist=[];
          }
        });
      }

  ongetCountries(){
      let CodeGroup =this.carrierpromoDetails.tilaCodeGroup;
      console.log(CodeGroup);
    this.promotionService.getCountries(CodeGroup).subscribe(
      res => {
        let _carriers: any = res;
        if (_carriers.httpcode == 200) {
          this.serviceCountries = _carriers.data;
        }
      });
    }
    ongetCarriersList(){
      let CodeGroup =this.carrierpromoDetails.tilaCodeGroup;
      let country = this.carrierpromoDetails.tilaCountry;
      this.promotionService.getCarriersList(CodeGroup,country).subscribe(
        res => {
          let _carriers: any = res;
          if (_carriers.httpcode == 200) {
            this.promotionsCarriers = _carriers.data;
          }
        });
      }
      ongetsku(){
        ///getcarriers
        let country = this.carrierpromoDetails.tilaCountry;
        let CodeGroup = this.carrierpromoDetails.tilaCodeGroup;
        let carrier = this.carrierpromoDetails.tilaCarrier;

        this.promotionService.getSKU(country,CodeGroup,carrier).subscribe(
          res => {
            let _carriers: any = res;
            if (_carriers.httpcode == 200) {
              this.skulist = _carriers.data;

            }
          });
        }

  getcarriers(e){
      ///getcarriers
      let country =this.carrierPromoForm.get('tilaCountry').value;
      let CodeGroup:any = Array();
      CodeGroup.push(this.carrierPromoForm.get('tilaCodeGroup').value);
      this.promotionService.getCarrierNamesbycountrycodegroup(country,CodeGroup).subscribe(
        res => {
          let _carriers: any = res;
          if (_carriers.httpcode == 200) {
            this.promotionsCarriers = _carriers.data;

          }
        });
      }

      getsku(e){
        ///getcarriers
        let country =this.carrierPromoForm.get('tilaCountry').value;
        let CodeGroup = this.carrierPromoForm.get('tilaCodeGroup').value
        let carrier =this.carrierPromoForm.get('tilaCarrier').value;

        this.promotionService.getSKU(country,CodeGroup,carrier).subscribe(
          res => {
            let _carriers: any = res;
            if (_carriers.httpcode == 200) {
              this.skulist = _carriers.data;

            }
          });
        }

        checkSubmitDisplayed() {
          return !(this.carrierPromoForm.valid && !this.carrierPromoForm.pristine);
        }
      }
